import { $, $$, closest } from 'utils/dom';

class Form {
  constructor(props) {
    this.target = props.target;
    this.label = props.label;
    this.wrapper = props.wrapper;
    this.formItem = props.formItem;
    this.activeClass = 'is-focused';
    this.disabledClass = 'is-disabled';
  }

  checkInput = () => {
    // if target field already has a value or a placeholder, add css class to prevent animation
    // and set label to default position
    if (
      this.target.value !== '' ||
      (this.target.placeholder !== '' && this.target.placeholder !== ' ')
    ) {
      this.label.classList.add(this.activeClass);
    }

    // if target field is disabled, add css class to prevent animation
    // and set label to default position
    this.target.disabled === true &&
      this.label.classList.add(this.disabledClass);
  };

  checkDisabled = () => {
    this.target.disabled === true &&
      this.formItem.classList.add(this.disabledClass);
  };

  onResize = () => {
    const self = this;

    // if user resize textarea, resize wrapper too, to prevent focus-state style bug
    self.target.addEventListener('mousedown', function () {
      self.wrapper.style.width = `${self.target.clientWidth}px`;

      self.target.onmousemove = function () {
        $(`#${self.target.id}`).blur();
        self.animateOut();

        setTimeout(function () {
          self.wrapper.setAttribute('style', '');
        }, 250);
      };
    });

    self.target.addEventListener('mouseup', function () {
      self.target.onmousemove = null;
      self.wrapper.style.width = `${self.target.clientWidth}px`;
    });
  };

  animateIn = () => {
    this.label.classList.add(this.activeClass);
    this.wrapper.classList.add(this.activeClass);
  };

  animateOut = () => {
    this.target.value === '' && this.label.classList.remove(this.activeClass);
    this.wrapper.classList.remove(this.activeClass);
  };

  bindEvents = () => {
    this.target.addEventListener('focusin', this.animateIn);
    this.target.addEventListener('focusout', this.animateOut);
  };

  init = () => {
    this.checkInput();
    this.checkDisabled();
    this.bindEvents();
    this.target.type === 'textarea' && this.onResize();

    setTimeout(this.checkInput, 500);
  };
}

const formfields = $$(
  '.o-form__field--input, .o-form__field--textarea, .o-form__field--select'
);

if (formfields.length) {
  formfields.forEach(formfield => {
    const formItem = closest(formfield, '.o-form__item');
    const wrapper = closest(formfield, '.o-form__container');

    new Form({
      target: formfield,
      label: $('.o-form__label', wrapper),
      wrapper,
      formItem,
    }).init();
  });
}
